import { FC, Dispatch, SetStateAction } from 'react';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { CreateTeamRoleAssignmentForm } from './CreateTeamRoleAssignmentForm';

export const CreateTeamRoleAssignmentDrawer: FC<{
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}> = ({ open, setOpen }) => {
  return (
    <WbDrawer open={open} setOpen={setOpen} title="Assign Team Role" size={30}>
      <CreateTeamRoleAssignmentForm />
    </WbDrawer>
  );
};
